
import {throwError,  ReplaySubject ,  Observable, of, forkJoin } from 'rxjs';
import { Injectable } from '@angular/core';
import { map, flatMap, tap, catchError } from 'rxjs/operators';

import { AccountService } from './account.service';
import { UserService } from './user.service';
import { WebApi } from 'app/core/web-api.service';

@Injectable()
export class AuthService {

    private _isAuth = new ReplaySubject<boolean>(1);

    constructor(
        private _accountService: AccountService,
        private _userService: UserService,
        private _webApi: WebApi) {
        this._webApi.events.subscribe(eventName => {
            if (eventName === 'error'
                || eventName === 'logout') {
                this._isAuth.next(false);
            }
        });
    }

    get isAuth(): Observable<boolean> {
        return this._isAuth.asObservable();
    }

    init(): Promise<void> {
        return this._init().pipe(catchError(() => of(void 0))).toPromise();
    }

    login(email: string, password: string): Observable<void> {
        return this._webApi.login(email, password).pipe(flatMap(() => this._init()));
    }

    logout(): Observable<void> {
        return this._webApi.logout().pipe(tap(() => this._isAuth.next(false)));
    }

    register(user): Observable<void> {
        this._removeEmptyFields(user);
        return this._webApi
            .register(user)
            .pipe(flatMap(() => this._init()));
    }

    recoverPassword(email: string, resetPasswordUrl: string): Observable<void> {
        return this._webApi.recoverPassword(email, resetPasswordUrl);
    }

    changePassword(password: string, token: string): Observable<void> {
        return this._webApi.changePassword(password, token);
    }

    private _init(): Observable<void> {
        return forkJoin([
            this._accountService.init(),
            this._userService.init()
        ]).pipe(
            map(() => {
                this._isAuth.next(true);
            }),
            catchError(response => {
                this._isAuth.next(false);
                return throwError(response);
            })
        );
    }

    private _removeEmptyFields(obj) {

        function isEmpty(value) {
            return value === null
                || value === undefined
                || value === '';
        }

        for (const key of Object.keys(obj)) {
            if (isEmpty(obj[key])) {
                delete obj[key];
            }
        }
    }
}
